const Page505 = () => {
  return <div>Page505</div>;
};
export default Page505;
